'use client';

import { c as _c } from "react/compiler-runtime";
import { SKUSelectionCta } from '@src/components/SKUSelectionCta/SKUSelectionCta';
import type { SKUSelectionFooterProps } from '@src/components/SKUSelectionFooter/SKUSelectionFooter.props';
import { StickyFooter } from '@src/components/StickyFooter/StickyFooter';
import { isSelectionStateValid, useSKUSelectionStore } from '@src/stores/SKUSelectionStore';
import { useBreakpoints } from '@src/utils/breakpoints.util';
import { cn } from '@src/utils/tailwind';
export const SKUSelectionFooter = props => {
  const $ = _c(16);
  const {
    buttonCopy,
    heading,
    invalidStateMessage,
    stickyFooterProps,
    redirectUrl,
    extraSkus
  } = props;
  const groups = useSKUSelectionStore(_temp);
  const groupRestrictions = useSKUSelectionStore(_temp2);
  const isValid = isSelectionStateValid(groups, groupRestrictions);
  const {
    isDesktop
  } = useBreakpoints();
  const T0 = StickyFooter;
  const t0 = "h-[152px] py-0 lg:h-[100px] lg:py-0";
  const t1 = "flex flex-col items-center gap-4 lg:flex-row lg:justify-between";
  const t2 = "flex flex-col text-center lg:text-left";
  let t3;
  if ($[0] !== heading) {
    t3 = <h2 className="text-heading-display-3 text-white">{heading}</h2>;
    $[0] = heading;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = (!isDesktop || !isValid) && <p className={cn("text-body-sm text-bodi-gray-butters", {
    "opacity-0": isValid
  })} dangerouslySetInnerHTML={{
    __html: invalidStateMessage ?? ""
  }} />;
  let t5;
  if ($[2] !== t3 || $[3] !== t4) {
    t5 = <div className={t2}>{t3}{t4}</div>;
    $[2] = t3;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== buttonCopy || $[6] !== extraSkus || $[7] !== redirectUrl) {
    t6 = <SKUSelectionCta copy={buttonCopy} redirectUrl={redirectUrl} extraSkus={extraSkus} />;
    $[5] = buttonCopy;
    $[6] = extraSkus;
    $[7] = redirectUrl;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className={t1}>{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== T0 || $[13] !== stickyFooterProps || $[14] !== t7) {
    t8 = <T0 {...stickyFooterProps} className={t0}>{t7}</T0>;
    $[12] = T0;
    $[13] = stickyFooterProps;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
function _temp(state) {
  return state.groups;
}
function _temp2(state_0) {
  return state_0.groupRestrictions;
}